import React, { useContext, useState, useEffect } from 'react';
import { Row } from 'antd';

import { SwitchCustom } from '../../components/SwitchCustom';

import { Context } from './context';

export function MigracaoControle({ activeMigration }) {
  const [activeMigracao, setActiveMigracao] = useState(activeMigration);
  const { setIsActiveMigrationSwitch } = useContext(
    Context
  );

  useEffect(() => {
    setActiveMigracao(activeMigration);
  }, [activeMigration]);

  useEffect(() => {
    setIsActiveMigrationSwitch(activeMigracao);
  }, [activeMigracao]);

  return (
    <Row>
      <SwitchCustom
        change={setActiveMigracao}
        checked={activeMigracao}
        size="small"
        title="Ativar Migração"
        color="#828282"
        fontSize={14}
        reverse
      />
    </Row>
  );
}
